module.exports = __webpack_public_path__ + "media/images/lb/404-8027deac2098dc583ae340585d2d5798.svg";